<template >
    <div class="container bg-white py-5 px-5" v-if="school && rootlesson">
      <h3>{{school.name}} </h3>
      <p>Хичээл: {{rootlesson.name}}</p>
      <p>Кредит: {{rootlesson.credit}}</p>
      <p>Код: {{rootlesson.lectureCode}}</p>

      <!-- <button type="button" class="btn btn-primary my-3" @click="_addProgram()">
        Төлөвлөгөөнд хичээл нэмэх
      </button> -->

      <!-- DataTales Example -->
      <div class="card shadow my-4" v-for="(semester) in semesters" v-bind:key="semester.id">
        <div class="card-header row m-0">
          <div class="col">
            <h4>{{semester.title}}</h4>
          </div>
          <div v-if='semester.default==true' class="col-auto">
            <div class="btn btn-success btn-sm" @click="_addProgram(semester)">Хичээл нэмэх</div>

          </div>

        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="semester.lessons!=null && semester.lessons.length>0">
              <thead>
                <tr>
                  <th>№</th>
                  <th style="width: 28%">Нэр</th>
                  <th>Xичээлийн код</th>
                  <th>Заах багш</th>
                  <th>Төлөв</th>
                  <th>Үйлдэл</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="(lesson, index) in semester.lessons" v-bind:key="lesson.id">
                  <td>{{index+1}}</td>
                  <td>{{lesson.name}}</td>
                  <td>{{lesson.lectureCode}}</td>
                  <td>
                    <div v-if="lesson.teachedBy">
                      <span v-if="lesson.teachedBy.name">
                        {{lesson.teachedBy.name}}
                        <br/>
                      </span>
                      <span v-if="lesson.teachedBy.code">
                        {{lesson.teachedBy.code}}
                        <br/>
                      </span>
                      <span v-if="lesson.teachedBy.email">
                        {{lesson.teachedBy.email}}
                      </span>
                    </div>

                  </td>
                  <td>
                    <h6 v-if="lesson.published==true" style="cursor:pointer"><span class="badge badge-success">Нээлттэй</span></h6>
                    <h6 v-else style="cursor:pointer"><span class="badge badge-danger" >Хаалттай</span></h6>
                  </td>
                  <td>
                    <div class="row">
                      <button class="btn  btn-outline-primary btn-sm mx-1" @click="goDetail(lesson)">хараx</button>
                      <button class="btn btn-warning btn-sm mx-1" @click="edit(lesson)">засах</button>
                      <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                      <button class="btn  btn-outline-success btn-sm mx-1" @click="$router.push({ name: 'LessonStudent', params: { lessonId: lesson.id, schoolId: schoolId} })" >оюутан</button>
                      
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div v-else class="alert alert-info text-center">Та {{semester.title}} семестерт ямар нэгэн хичээл оруулаагүй байна.</div>
          </div>
        </div>
      </div>

      <!-- Modal -->
      <div class="modal fade" id="proModal" tabindex="-1" role="dialog" aria-labelledby="proModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header" v-if="school && rootlesson">
              <h5 class="modal-title" id="proModalLabel">Заах хичээл нэмэх</h5>
              <p>{{school.name}} / {{rootlesson.name}} / <span v-if="selectedSemester">{{selectedSemester.title}}</span> </p>
              <!-- <p>{{programYear.name}} - <span v-if="programYear.startDay">{{programYear.startDay.year}}</span></p> -->
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <form class="user">
                <div class="row">
                  <div class="col form-group">
                    <label for="exampleFormControlSelect1">Заах багш :</label>
                    <div class="row">
                      <div class="col col-expand">
                        <select class="form-control" v-model="selectedTeacher">
                          <option v-for="teacher in teachers" v-bind:value="teacher">{{teacher.name}} - {{teacher.code}} - {{teacher.email}}</option>
                        </select>
                      </div>
                      <div class="col-auto">
                        <button class="btn btn-success" type="button" @click="addTmpTeacher(selectedTeacher)">нэмэх</button>
                      </div>
                    </div>
                    <div class="table-responsive">

                      <table class="table table-bordered mt-3" v-if="tmpTeachers && tmpTeachers.length>0">
                        <tr v-for="teacher in tmpTeachers">
                          <td>{{teacher.lastname}}/  {{teacher.name}}</td>
                          <td>{{teacher.code}}</td>
                          <td>{{teacher.email}}</td>
                          
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>

                <hr>
                <p class="text-center">Та  <span class="text-danger" v-if="selectedSemester">{{selectedSemester.title}}</span>  '{{rootlesson.name}}' хичээлийг заах багш нараа сонгоод нэмнэ үү.</p>
                
                <p class="text-center">Та сонгосон багш тус бүр дээр заах хичээл үүсгэхийг хүсвэл хичээл үүсгэх товч дээр дарна уу.</p>
                
              </form>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Цуцлаx</button>
              <button @click="createLessons" type="button" class="btn btn-primary btn-user btn-block" data-dismiss="modal">Хичээл үүсгэх</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
</template>

<script>
const fb = require('../../firebaseConfig.js')
import { mapState } from 'vuex'
import moment from 'moment'

export default {
    name: "RootLessonDetail",
    data() {
        return {
          rootlesson:null,
          school:null,
          department: null,
          program:null,
          programYear:null,
          pros:[],
          semesters:[],
          selectedSemester:null,
          teachers:[],
          tmpTeachers:[],
          selectedTeacher:null       
        };
    },
    methods: {
        
      async _getQA(){
        var doc=await fb.db.doc("schools/"+this.schoolId).get();
        let department=doc.data();
        department.id=doc.id;
        this.school=department;

        // fb.db.collection("teachers").where("school", "==", doc.ref).get().then(docs=>{
        //   this.teachers=[];
        //   docs.docs.forEach(tdoc=>{
        //     let teacher=tdoc.data();
        //     teacher.id=tdoc.id;
        //     teacher.ref=tdoc.ref;
        //     this.teachers.push(teacher);
        //   });
        // });


        var aquerySnapshot=await fb.db.collection("admins")
        .where("schools", "array-contains", fb.db.collection("schools").doc(this.schoolId))
        .where("role", "==", "sts").get();
        aquerySnapshot.forEach(paymentData=> {
          let object=paymentData.data();
          object.ref=paymentData.ref;
          object.id=paymentData.id;
          if(!object.code)
                object.code='admin';

          this.teachers.push(object);
        });



        var querySnapshot=await fb.db.collection("teachers").where("school", "==", fb.db.collection("schools").doc(this.schoolId)).orderBy("name").get();
        querySnapshot.forEach(paymentData=> {
          let object=paymentData.data();
          object.ref=paymentData.ref;
          object.id=paymentData.id;

          this.teachers.push(object);
        });

        fb.db.collection("schools/"+this.schoolId+"/rootlessons").doc(this.rootLessonId).get().then(doc=> {
            let department=doc.data();
            department.ref=doc.ref;
            department.id=doc.id;
            this.rootlesson=department;
        });

        fb.db.collection("semester").where("default", "==", true).get().then(docs=>{
          this.semesters=[];
          docs.docs.forEach(doc=>{
            let object=doc.data();
            object.id=doc.id;
            object.ref=doc.ref;
            object.lessons=[];
            fb.db.collection("lessons")
              .where("semester", "==", doc.ref)
              .where("rootlesson", "==", this.rootlesson.ref)
              .onSnapshot(querySnapshot1=> {
              object.lessons=[];
              querySnapshot1.forEach(lessonDoc=> {
                  let lesson=lessonDoc.data();
                  lesson.id = lessonDoc.id;
                  lesson.teachedBy=null;
                  if(lesson.teacher){
                    lesson.teacher.get().then(tdoc=>{
                      if(tdoc.exists){
                        lesson.teachedBy=tdoc.data();
                      }
                    });
                  }
                  object.lessons.push(lesson);
              });
            });
            this.semesters.push(object);
          });
        });


      },

      _addProgram(semester){
        this.selectedSemester=Object.assign({}, semester);
        this.tmpTeachers=[];
        this.selectedTeacher=null;

        $('#proModal').modal('toggle');
      },

      goDetail(lesson){
        // if(lesson.isBlock!=true && (lesson.school==null || lesson.department==null || lesson.program==null)){
        //   alert("Та эхлээд хичээлийнхээ сургууль , тэнхим болон хөтөлбөрийг сонгоно уу");
        //   this.$router.push({ name: 'LessonEdit', params: { lessonId: lesson.id} });
        // }
        // else
          this.$router.push({ name: 'LessonDetailAdmin', params: { lessonId: lesson.id} })
      },
      edit(lesson){
            this.$router.push({ name: 'ILessonAdd', params: { schoolId: this.schoolId ,lessonId: lesson.id, setTeacher:true} })
      },
      addTmpTeacher(teacher){
        this.tmpTeachers.push(Object.assign({}, teacher));
        this.selectedTeacher=null;
      },
      createLessons(){
        if(this.selectedSemester && this.tmpTeachers && this.tmpTeachers.length>0 && this.rootlesson && this.school){
          var batch=fb.db.batch();

          for(const teacher of this.tmpTeachers){
            var lessonname=this.rootlesson.name?this.rootlesson.name: "";
            if(teacher && teacher.name){
              lessonname=lessonname+" /"+teacher.name+"/";
            }
            var lesson={
              name:lessonname,
              teacher: teacher.ref,
              teachers:[
                {
                  firstName:teacher.name?teacher.name:"-",
                  lastName:teacher.lastname?teacher.lastname: "-",
                  reference: teacher.ref,
                  
                }
              ],
              teacherRefs:[
                teacher.ref
              ],
              createdAt:new Date(),
              school: fb.db.collection("schools").doc(this.schoolId),
              department: this.rootlesson && this.rootlesson.department? this.rootlesson.department: null,
              published:false,
              credit: this.rootlesson && this.rootlesson.credit? this.rootlesson.credit: null,
              isBlock:false,
              lectureCode: this.rootlesson && this.rootlesson.lectureCode? this.rootlesson.lectureCode: null,
              rootlesson: this.rootlesson? this.rootlesson.ref:null,
              semester: this.selectedSemester.ref,
              teacherFirstName:teacher.name?teacher.name:"-",
              teacherLastName:teacher.lastname?teacher.lastname: "-",
              user:fb.usersCollection.doc(this.$store.getters.currentUser.uid),
              userId:this.$store.getters.currentUser.uid

            }


            batch.set(
              fb.db.collection("lessons").doc(),
              lesson
            );
          }

          batch.commit();

          this.selectedSemester=null
          this.tmpTeachers=[];
          this.selectedTeacher=null;
        }
      }

    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    props: {
        schoolId: { 
            required: true,
        },
        rootLessonId:{
          required:true
        }
    },
    created() {
        if(this.schoolId!=null && this.schoolId!='' && this.rootLessonId)
          this._getQA();
            
    },
    filters: {
		  formatDate(val) {
        if(val!=null){
          if (!val) { return '-' }
          let date = val.toDate()
          return moment(date).fromNow()
        }
        return '-'
      },
    
    }
  
};
</script>

